import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { CalendarDays, Phone, MapPin } from "lucide-react";
import { AddToCalendar } from "@/components/public/AddToCalendar";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const when = (iso) => { const d = new Date(iso.slice(0, 16)); return `${d.toLocaleDateString("en-AU", { weekday: "long", day: "numeric", month: "long" })} at ${d.toLocaleTimeString("en-AU", { hour: "numeric", minute: "2-digit" }).toLowerCase()}`; };

// Public, no-login page behind the "Your appointments" short link in reminders/confirmations.
export default function MyBookings() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { axios.get(`${API}/public/my/${token}`).then((r) => setD(r.data)).catch(() => setErr("This link isn't valid any more.")); }, [token]);
  const c = d?.clinic || {};
  return (
    <div className="min-h-screen bg-background flex items-start justify-center p-4 sm:p-8" data-testid="my-bookings-page">
      <div className="w-full max-w-md space-y-4">
        <div className="text-center pt-4">
          {c.logo_url ? <img src={c.logo_url} alt={c.name} className="h-14 mx-auto object-contain" /> : <div className="font-heading font-bold text-2xl">{c.name || "Azordi"}</div>}
        </div>
        {err && <div className="rounded-2xl border bg-card p-6 text-center text-muted-foreground" data-testid="my-bookings-error">{err}</div>}
        {d && (
          <>
            <h1 className="font-heading font-semibold text-xl text-center">Hi {d.first_name}, here's what's coming up</h1>
            {d.upcoming.length === 0 ? (
              <div className="rounded-2xl border bg-card p-6 text-center text-muted-foreground" data-testid="my-bookings-empty">You have no upcoming appointments.</div>
            ) : d.upcoming.map((b) => (
              <div key={b.id} className="rounded-2xl border bg-card p-4 shadow-sm" data-testid={`my-booking-${b.id}`}>
                <div className="flex items-start gap-3">
                  <div className="h-10 w-10 rounded-xl bg-primary/10 flex items-center justify-center shrink-0"><CalendarDays className="h-5 w-5 text-primary" /></div>
                  <div><div className="font-semibold">{when(b.start)}</div><div className="text-sm text-muted-foreground">{b.service_name}{b.staff_name ? ` with ${b.staff_name}` : ""}</div></div>
                </div>
                <div className="mt-3 sm:pl-[52px]"><AddToCalendar icsUrl={`${process.env.REACT_APP_BACKEND_URL}/api/public/my/${d.token || token}/bookings/${b.id}/invite.ics`} title={`${b.service_name || "Appointment"} — ${c.name || ""}`} start={b.start} end={b.end} durationMin={b.duration} location={c.address || ""} details={`${b.service_name || "Appointment"}${b.staff_name ? ` with ${b.staff_name}` : ""} at ${c.name || ""}. Manage: ${window.location.href}`} testid={`my-booking-cal-${b.id}`} /></div>
              </div>
            ))}
            <div className="rounded-2xl border bg-card p-4 text-sm space-y-1.5">
              <div className="font-medium">{c.name}</div>
              {c.address && <div className="text-muted-foreground flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5" />{c.address}</div>}
              {c.phone && <a href={`tel:${c.phone}`} className="text-primary flex items-center gap-1.5" data-testid="my-bookings-call"><Phone className="h-3.5 w-3.5" />{c.phone}</a>}
              <p className="text-xs text-muted-foreground pt-1">Need to change something? Call or text us and we'll sort it.</p>
            </div>
            {c.slug && <Link to={`/book/${c.slug}`} className="block text-center text-sm text-primary underline" data-testid="my-bookings-book">Book another appointment</Link>}
          </>
        )}
      </div>
    </div>
  );
}
